import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { CheckSquare, Loader2 } from "lucide-react";
import { toast } from "sonner";

const BG = "https://images.unsplash.com/photo-1549791084-5f78368b208b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwxfHxjbGVhbiUyMG1pbmltYWwlMjBtb2Rlcm4lMjBvZmZpY2UlMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzgzMDU2MzEwfDA&ixlib=rb-4.1.0&q=85";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      toast.success("Bienvenido");
      navigate(res.user.role === "admin" ? "/dashboard" : "/hoy");
    } else {
      toast.error(res.error);
    }
  };


  return (
    <div className="flex min-h-screen">
      <div className="relative hidden w-1/2 lg:block">
        <img src={BG} alt="" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-slate-900/70" />
        <div className="absolute inset-0 flex flex-col justify-between p-12 text-white">
          <div className="flex items-center gap-2">
            <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-white/15 backdrop-blur">
              <CheckSquare className="h-6 w-6" />
            </div>
            <span className="font-heading text-lg font-extrabold">Calendario VH</span>
          </div>
          <div>
            <h1 className="font-heading text-4xl font-extrabold leading-tight">Control operativo<br />de tareas empresariales</h1>
            <p className="mt-4 max-w-md text-slate-300">Asigna, da seguimiento y mide el cumplimiento de tu equipo en tiempo real.</p>
          </div>
          <div className="text-xs text-slate-400">SIMPLICIDAD · VELOCIDAD · TRAZABILIDAD · CUMPLIMIENTO</div>
        </div>
      </div>

      <div className="flex w-full items-center justify-center bg-slate-50 p-6 lg:w-1/2">
        <div className="w-full max-w-sm">
          <div className="mb-8 flex items-center gap-2 lg:hidden">
            <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-slate-900 text-white">
              <CheckSquare className="h-6 w-6" />
            </div>
            <span className="font-heading text-lg font-extrabold text-slate-900">Calendario VH</span>
          </div>
          <h2 className="font-heading text-2xl font-extrabold text-slate-900">Iniciar sesión</h2>
          <p className="mt-1 text-sm text-slate-500">Ingresa a tu panel de control</p>

          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <Label>Correo electrónico</Label>
              <Input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="tu@empresa.com" className="mt-1" required />
            </div>
            <div>
              <Label>Contraseña</Label>
              <Input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" className="mt-1" required />
            </div>
            <Button data-testid="login-submit" type="submit" disabled={loading} className="w-full rounded-full bg-slate-900 py-6 text-base font-bold hover:bg-slate-800 active:scale-95">
              {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : "Entrar"}
            </Button>
          </form>

          
          </div>
        </div>
      </div>
  );
}
